import { Host, h, getAssetPath } from "@stencil/core";
import state from "../store";
export class GxgGrid {
    constructor() {
        this.noBorder = false;
        this.fullHeight = false;
    }
    el;
    componentWillLoad() {
        const iconsUrl = getAssetPath("./icon-assets/");
        this.el.style.setProperty("--refreshIconUrl", `url("${iconsUrl}gemini-tools/reset.svg")`);
        this.el.style.setProperty("--settingshIconUrl", `url("${iconsUrl}gemini-tools/settings.svg")`);
        this.el.style.setProperty("--barSortAscendingIconUrl", `url("${iconsUrl}navigation/chevron-down.svg")`);
        this.el.style.setProperty("--barSortDescendingIconUrl", `url("${iconsUrl}navigation/chevron-up.svg")`);
        this.el.style.setProperty("--barSettingsButtonIconUrl", `url("${iconsUrl}gemini-tools/settings.svg")`);
        this.el.style.setProperty("--settingsCloseIconUrl", `url("${iconsUrl}gemini-tools/close.svg")`);
        this.el.style.setProperty("--dragIconUrl", `url("${iconsUrl}navigation/drag.svg")`);
        this.el.style.setProperty("--caretCollapseIconUrl", `url("${iconsUrl}gemini-tools/minus.svg")`);
        this.el.style.setProperty("--caretExpandIconUrl", `url("${iconsUrl}gemini-tools/add.svg")`);
    }
    render() {
        return (h(Host, { class: { large: state.large, "no-border": this.noBorder } }, h("slot", null)));
    }
    static get is() { return "gxg-grid"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-grid.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-grid.css"]
        };
    }
    static get properties() {
        return {
            "noBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "no-border",
                "reflect": true,
                "defaultValue": "false"
            },
            "fullHeight": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "full-height",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=gxg-grid.js.map
